import { createIframe, listaErrores } from "helpers/helpers";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  RegisterAcceso,
  RequestEnvioWhatsapp,
  RequestSaveMediosContacto,
  RequestVerifyQRCode,
  filesIne,
} from "interfaces/accesoEdificios/accesoEdificiosInterface";
import {
  getCodigoQRDownloadService,
  getCodigoQRService,
  getDatosQREscaneadoService,
  getDatosUsuarioCurpService,
  getDiscapacidadesService,
  getJuzgadosEdificiosService,
  getSubDiscapacidadesService,
  postAccesoEdificiosService,
  postDiscapacidades,
  postEnvioWhatsapp,
  postIdentificaciones,
  postenvioCorreo,
  saveMediosContactoService,
  verifyQRCodeService,
} from "services/accesoEdificios/accesoEdificiosService";
import { setIsLoading, setMessageLoading } from "store";
import {
  onChangeConMenor,
  onChangeDiscapacidad,
  onDeleteMenor,
  onLoadDataQR,
  onLoadDatosUsuario,
  onLoadFileIneAtras,
  onLoadFileIneFrente,
  onLoadInforQr,
  onLoadJuzgadosEdificios,
  onLoadLstDiscapacidades,
  onLoadLstSubDiscapacidades,
  onLoadMenor,
  onLoadVerifyQR,
} from "store/accesoEdificios/accesoEdificiosSlice";
import Swal from "sweetalert2";
export const useAccesoEdificios = () => {
  const dispatch = useAppDispatch();
  const {
    datosUsuario,
    fileIneF,
    fileIneR,
    lstJuzgadosEdificios,
    qrGenerated,
    infoQr,
    lstDiscapacidades,
    lstMenores,
    conMenor,
    discapacidad,
    dataQR,
    lstSubdiscapacidades,
  } = useAppSelector((state) => state.accesoEdificios);
  const { user } = useAppSelector((state) => state.auth);
  const startGetJuzgadosEdificio = () => {
    getJuzgadosEdificiosService()
      .then(({ data }) => {
        let newData = data.data?.map((pJuz) => {
          return {
            /* 
            ¬000026http://localhost:3030/qr-scanned/GOML0003-99991212
            127.0.0.1/qr-scanned/GOML0003-99991212
            ¬000026http://localhost:3030/qr-scanned/GOML000304HHGMNSA1/LUIS%20ALBERTO/GOMEZ/MONROY/MASCULINO/albertogmonroygmail.com/5632724297
            ¬000026eyJpdiI6ImpjZmc3WnJnWDhzc1kyV0UyWUNpaEE9PSIsInZhbHVlIjoiZ3NmWmJOTmhTNWIwYnQyVVdCQ2swSlBmckpsekNxa1BWODFDem95amRhK1o0djZvanR1Z0UrNVB0dzM0OEVqTkFXOTV6WHlWcHZ5RHErU1k0V1EzSFRINC92Q3I4WjZrV1ZiemFDd1hnVjBYTHZiRWw5T2tUYTY3ZFh5T2pSaFlCU1pyUHlPQkVXTjNHU2Z0UUdCVWQrYUtodU81d3MyaGJmUnNIOXc0YVdlOE1jbXVUMW1ieWQ1eFdEYm1uVmtMIiwibWFjIjoiOGUzMWMyOTFjMjYyYTdkMTkzNTZjMjQ0MmY5MDIwNWZkZDhlOWE2ZjBmNTIyNTFkN2QyNWI0MGI4YjJjYzZiMCIsInRhZyI6IiJ9
            Texto o URL para el c{odigo QR
            }
             */
            ...pJuz,
            nombre: pJuz?.NomEdificio,
            direccion: `${pJuz?.Direccion} ${pJuz?.colonia} ${pJuz?.cp}`,
            imgPath:
              "https://wallpapers.com/images/high/hd-farm-at-sunset-xwh3uz0jo2fw2u26.webp",
            coordenadas: {
              latitud: pJuz?.latitud,
              longitud: pJuz?.longitud,
            },
          };
        });
        dispatch(onLoadJuzgadosEdificios(newData));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const startGetDatosUsuarioCurp = (curp: string) => {
    getDatosUsuarioCurpService(curp)
      .then(({ data }) => {
        dispatch(onLoadDatosUsuario(data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const startVerifyUserQR = (body: RequestVerifyQRCode) => {
    verifyQRCodeService(body)
      .then(({ data }) => {
        dispatch(onLoadVerifyQR(data.data));
      })
      .catch((err) => {
        dispatch(onLoadVerifyQR(err?.response?.data?.error_show));
        console.log(err);
      });
  };
  const saveAccesoEdificio = (pBody: RegisterAcceso) => {
    dispatch(setIsLoading(true));
    postAccesoEdificiosService(pBody)
      .then(({ data }) => {
        Swal.fire({
          title: "Correcto",
          text: "Información guardada correctamente",
          icon: "success",
          confirmButtonColor: "#9b0000",
        });
        startGetDatosUsuarioCurp(String(pBody?.curp));
        startGetCodigoQR(String(pBody?.curp));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        dispatch(setIsLoading(false));
        Swal.fire({
          title: `Ha ocurrido un error al guardar  el reporte`,
          text: err?.response?.data?.error_msg || "Hubo un problema",
          icon: "warning",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#6e7881",
          html: `
          <style>
          h4, h5{
            font-family: arial;
            color: #545454;
          }
        </style>
          <h4>${
            err?.response?.data?.data ||
            err?.response?.data?.error_msg ||
            "Hubo un problema"
          }</h4>
          <h5>${err?.response?.data?.error_data || "Hubo un problema"}</h5>
          <div id="lista-errores"></div>
         `,
        });
        listaErrores(err);
      });
  };
  const startGetCodigoQR = (pBody: string) => {
    getCodigoQRService(pBody)
      .then(({ data }) => {
        dispatch(onLoadDataQR(data.data));
      })
      .catch(() => {
        dispatch(onLoadDataQR(null));
      });
  };
  const startDowloadQR = (pBody: string) => {
    dispatch(setIsLoading(true));
    getCodigoQRDownloadService(pBody)
      .then(({ data }) => {
        const fileUrl = window.URL.createObjectURL(
          new Blob([data], { type: "application/pdf" })
        );
        createIframe(fileUrl);
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        dispatch(setIsLoading(false));
        Swal.fire({
          title: `Ha ocurrido un error al guardar  el reporte`,
          text: err?.response?.data?.error_msg || "Hubo un problema",
          icon: "warning",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#6e7881",
          html: `
          <style>
          h4, h5{
            font-family: arial;
            color: #545454;
          }
        </style>
          <h4>${err?.response?.data?.data || "Hubo un problema"}</h4>
          <h5>${err?.response?.data?.error_data || "Hubo un problema"}</h5>
          <div id="lista-errores"></div>
         `,
        });
        listaErrores(err);
      });
  };
  const setIneFrente = (pIne: filesIne) => {
    dispatch(onLoadFileIneFrente(pIne));
  };
  const setIneReversa = (pIne: filesIne) => {
    dispatch(onLoadFileIneAtras(pIne));
  };
  const startGetDatosQR = (pBody: string) => {
    dispatch(setIsLoading(true));
    getDatosQREscaneadoService(pBody)
      .then(({ data }) => {
        if (!data?.data) {
          Swal.fire({
            title: `Ha ocurrido un error al obtener la información del Qr`,
            text: "Hubo un problema",
            icon: "warning",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#6e7881",
            html: `
            <style>
            h4, h5{
              font-family: arial;
              color: #545454;
            }
          </style>
            <h4>${"El código QR que fue escaneado no es válido"}</h4>`,
          });
          let noValid = {
            idCodigoQR: 0,
            claveIdentificadorQr: "",
            rutaQR: "",
            fechaVigencia: "",
            vigente: "N",
            idPersonaAcceso: 0,
            nombreUsuario: "",
            curp: "",
            sexo: "",
            rutaIdentificacion: "",
          };
          dispatch(onLoadInforQr(noValid));
          dispatch(setIsLoading(false));
          return;
        }
        dispatch(onLoadInforQr(data.data));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        dispatch(setIsLoading(false));
        Swal.fire({
          title: `Ha ocurrido un error al obtener la información del Qr`,
          text: err?.response?.data?.error_msg || "Hubo un problema",
          icon: "warning",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#6e7881",
          html: `
          <style>
          h4, h5{
            font-family: arial;
            color: #545454;
          }
        </style>
          <h4>${
            err?.response?.data?.data ||
            err?.response?.data?.error_msg ||
            "Hubo un problema"
          }</h4>
          <h5>${err?.response?.data?.error_data || "Hubo un problema"}</h5>
          <div id="lista-errores"></div>
         `,
        });
        listaErrores(err);
      });
  };
  interface SubDiscapacidad {
    cveTipoSubdiscapacidad: number;
    cveTipoDiscapacidad: number;
    descTipoSubDiscapacidad: string;
    activo: string;
    fechaRegistro: string;
    fechaActualizacion: string;
  }

  interface Discapacidad {
    cveTipoDiscapacidad: number;
    descTipoDiscapacidad: string;
    activo: string;
    fechaRegistro: string;
    fechaActualizacion: string;
    subDiscapacidades?: SubDiscapacidad[];
  }

  interface TreeSelectItem {
    key: string;
    label: string;
    activo: string;
    children?: TreeSelectItem[];
  }
  const startGetLstDiscapacidades = () => {
    getDiscapacidadesService()
      .then(({ data }) => {
        if (data && data.data) {
          const treeSelectData: TreeSelectItem[] = data.data.map(
            (item: Discapacidad | any) => {
              const treeItem: TreeSelectItem = {
                key: item.cveTipoDiscapacidad,
                label: item.descTipoDiscapacidad,
                activo: item.activo,
              };

              if (item.subDiscapacidades && item.subDiscapacidades.length > 0) {
                treeItem.children = item.subDiscapacidades.map(
                  (subItem: SubDiscapacidad) => ({
                    key: `${item.cveTipoDiscapacidad}-${subItem.cveTipoSubdiscapacidad}`,
                    label: subItem.descTipoSubDiscapacidad,
                    activo: subItem.activo,
                  })
                );
              }
              return treeItem;
            }
          );

          dispatch(onLoadLstDiscapacidades(treeSelectData));
        } else {
          console.log("Los datos recibidos no tienen la estructura esperada");
        }
      })
      .catch(() => {
        console.log("Error al obtener datos");
      });
  };
  const startGetLstSubDiscapacidades = (idDiscapacidad: number) => {
    getSubDiscapacidadesService(idDiscapacidad)
      .then(({ data }) => {
        dispatch(onLoadLstSubDiscapacidades(data.data));
      })
      .catch(() => {
        dispatch(onLoadLstSubDiscapacidades(null));
        console.log();
      });
  };

  const startSaveDiscapacidadesUsuario = (request: any) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Guardando información"));
    postDiscapacidades(request)
      .then(({ data }) => {
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
        Swal.fire({
          title: "Correcto",
          text: "Información guardada correctamente",
          icon: "success",
          confirmButtonColor: "#9b0000",
        });
        startGetCodigoQR(String(user.CURP));
        startVerifyUserQR({
          curp: String(user.CURP),
          idPersonaAutorizada: Number(user.session?.cveUsuario),
        });
      })
      .catch(() => {
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
        console.log();
      });
  };

  const startSaveIdentificacion = (request: any) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Guardando información"));
    postIdentificaciones(request)
      .then(({ data }) => {
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
        Swal.fire({
          title: "Correcto",
          text: "Información guardada correctamente",
          icon: "success",
          confirmButtonColor: "#9b0000",
        });
        startGetCodigoQR(String(user.CURP));
        startVerifyUserQR({
          curp: String(user.CURP),
          idPersonaAutorizada: Number(user.session?.cveUsuario),
        });
      })
      .catch(() => {
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
        console.log();
      });
  };

  const sendWhatsapp = (body: RequestEnvioWhatsapp) => {
    dispatch(setIsLoading(true));
    postEnvioWhatsapp(body)
      .then(() => {
        Swal.fire({
          title: "Correcto",
          text: "El mensaje de WhatsApp ha sido enviado exitosamente. Por favor, verifica tu aplicación de WhatsApp con el número registrado para confirmarlo.",
          icon: "success",
          confirmButtonColor: "#9b0000",
        });
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        dispatch(setIsLoading(false));
        Swal.fire({
          title: `Ha ocurrido un error al enviar Whatsapp`,
          text: err?.response?.data?.error_msg || "Hubo un problema",
          icon: "warning",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#6e7881",
          html: `
          <style>
          h4, h5{
            font-family: arial;
            color: #545454;
          }
        </style>
          <h4>${
            err?.response?.data?.data ||
            err?.response?.data?.error_msg ||
            "Hubo un problema"
          }</h4>
          <h5>${err?.response?.data?.error_data || "Hubo un problema"}</h5>
          <div id="lista-errores"></div>
         `,
        });
        listaErrores(err);
      });
  };

  const saveMediosContacto = (body: RequestSaveMediosContacto) => {
    dispatch(setIsLoading(true));
    saveMediosContactoService(body)
      .then(() => {
        Swal.fire({
          title: "Correcto",
          text: "Los medios de contacto se han guardado exitosamente.",
          icon: "success",
          confirmButtonColor: "#9b0000",
        });
        startVerifyUserQR({
          curp: String(user.CURP),
          idPersonaAutorizada: Number(user.session?.cveUsuario),
        });
        startGetCodigoQR(String(user.CURP));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        dispatch(setIsLoading(false));
        Swal.fire({
          title: `Ha ocurrido un error al guardar los medios de contacto`,
          text: err?.response?.data?.error_msg || "Hubo un problema",
          icon: "warning",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#6e7881",
          html: `
          <style>
          h4, h5{
            font-family: arial;
            color: #545454;
          }
        </style>
          <h4>${
            err?.response?.data?.data ||
            err?.response?.data?.error_msg ||
            "Hubo un problema"
          }</h4>
          <h5>${err?.response?.data?.error_data || "Hubo un problema"}</h5>
          <div id="lista-errores"></div>
         `,
        });
        listaErrores(err);
      });
  };

  const sendCorreo = (body: RequestEnvioWhatsapp) => {
    dispatch(setIsLoading(true));
    postenvioCorreo(body)
      .then(() => {
        Swal.fire({
          title: "Correcto",
          text: "Elcorreo electrónico ha sido enviado exitosamente. Por favor, verifica tu aplicación de correo con la dirección registrada para confirmarlo.",
          icon: "success",
          confirmButtonColor: "#9b0000",
        });
        
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        dispatch(setIsLoading(false));
        Swal.fire({
          title: `Ha ocurrido un error al enviar el correo`,
          text: err?.response?.data?.error_msg || "Hubo un problema",
          icon: "warning",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#6e7881",
          html: `
          <style>
          h4, h5{
            font-family: arial;
            color: #545454;
          }
        </style>
          <h4>${
            err?.response?.data?.data ||
            err?.response?.data?.error_msg ||
            "Hubo un problema"
          }</h4>
          <h5>${err?.response?.data?.error_data || "Hubo un problema"}</h5>
          <div id="lista-errores"></div>
         `,
        });
        listaErrores(err);
      });
  };
  const addLstMenor = (pMenor: any) => {
    dispatch(onLoadMenor(pMenor));
  };
  const deleteMenor = (pMenor: number) => {
    dispatch(onDeleteMenor(pMenor));
  };
  const changeDiscapacidad = (pDisc: Boolean) => {
    dispatch(onChangeDiscapacidad(pDisc));
  };
  const changeConMenor = (pConM: Boolean) => {
    dispatch(onChangeConMenor(pConM));
  };
  return {
    datosUsuario,
    dataQR,
    fileIneF,
    fileIneR,
    infoQr,
    lstDiscapacidades,
    lstJuzgadosEdificios,
    qrGenerated,
    lstMenores,
    conMenor,
    discapacidad,
    lstSubdiscapacidades,
    saveAccesoEdificio,
    setIneFrente,
    setIneReversa,
    startDowloadQR,
    startGetCodigoQR,
    startGetDatosQR,
    startGetDatosUsuarioCurp,
    startGetJuzgadosEdificio,
    startGetLstDiscapacidades,
    addLstMenor,
    deleteMenor,
    changeDiscapacidad,
    changeConMenor,
    sendWhatsapp,
    startVerifyUserQR,
    sendCorreo,
    saveMediosContacto,
    startGetLstSubDiscapacidades,
    startSaveDiscapacidadesUsuario,
    startSaveIdentificacion,
  };
};
